import "./About.css";

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12">
            <h2 className="about-heading text-center pe-md-5">About US</h2>
          </div>
          <div className="col-md-12 text-start">
            <p className="about-text">
              <strong>Broadway Building Solutions</strong> was born out of a
              simple realization — construction teams deserve better support
              solutions. With over a decade of experience in operations,
              logistics, and on-site coordination, co-founders Madhur Gulati and
              Karan Singh came together to bridge the gap between demanding
              project needs and reliable, fast-turnaround fencing services.
            </p>
            <p className="about-text">
              We don’t just deliver fences. We deliver peace of mind,
              professional service, and site-ready solutions — when and where
              you need them.
            </p>
            <div className="d-flex justify-content-center">
              <a
                href="/about-our-company"
                className="btn about-button text-white"
              >
                Learn more
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
